import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { switchMap, filter, tap } from 'rxjs/operators';
import { ModuleService } from './enabled-modules.service';
import { OrganizationService } from '../organization/organization.service';
import { BaseOrganizationProfile } from '../organization/organization';
import { ErrorRouter } from '../error/error-router.service';

@Injectable({
  providedIn: 'root',
})
export class ModuleEnabledGuard {
  constructor(
    private moduleService: ModuleService,
    private organizationService: OrganizationService<BaseOrganizationProfile>,
    private errorRouter: ErrorRouter,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    if (!route.data.requiredModule) {
      return of(false);
    }

    return this.organizationService.organization$.pipe(
      filter(organization => !!organization),
      switchMap(() => this.moduleService.isModuleEnabled$(route.data.requiredModule)),
      tap(canActivate => {
        if (!canActivate) {
          this.errorRouter.redirect(404);
        }
      }),
    );
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.canActivate(route, state);
  }
}
